import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  token: string | null;
  userInfo: Record<string, any> | null;
}

const initialState: AuthState = {
  token: null,
  userInfo: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken(state, action: PayloadAction<string>) {
      state.token = action.payload;
    },
    setUserInfo(state, action: PayloadAction<Record<string, any>>) {
      state.userInfo = action.payload;
    },
    clearAuth(state) {
      state.token = null;
      state.userInfo = null;
    },
  },
});

export const { setToken, setUserInfo, clearAuth } = authSlice.actions;
export default authSlice.reducer; 